import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "@material-ui/core/Button/Button";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import { Slide, TextField } from "@material-ui/core";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import SectionHeader from "../../../components/UI/SectionHeader";
import Typography from "@material-ui/core/Typography";
import userAction from "../../../actions/user.action";
import ErrorMessage from "../../../components/UI/ErrorMessage";

const styles = (theme) => ({
  paper: {
    width: "100%",
  },
  dialogContent: {
    maxHeight: 300,
  },
});

const VerifyCRD = (props) => {
  const [open, setOpen] = useState(false);
  const [crd, setCRD] = useState('');

  const dispatch = useDispatch();
  const { user, message } = useSelector((state) => state.user);
  const brokerCheck = useSelector((state) => state.brokerCheck);

  useEffect(() => {

    // Condition 1 - If a user was updated correctly and CRD was verified
    // Strictly check for a `true` value
    if (user.crdVerified === true) {
      setOpen(false);
    }
    // Condition 2 - If server was able to user but CRD is not verified due to an error
    // on Brokercheck, We will recieve a response and not an error in this case.
    else if (message && message.success) {
      setOpen(false);
    }
    // If Broker check was contacted correctly and CRD was deemed invalid
    // Strictly check for a `false` value
    else if (brokerCheck.healthy && user.crdVerified === false) {
      setOpen(true);
      setCRD(crd || user.advisorCrdRef);
    } 
  }, [ brokerCheck.healthy, user, message ]);

  const { classes } = props;

  return <Dialog
    open={open}
    TransitionComponent={Slide}
    TransitionProps={{ direction: "up" }}
    disableBackdropClick={true}
    disableEscapeKeyDown={true}
    aria-labelledby="no-rep-code-modal-title"
    maxWidth={"sm"}
    scroll={"paper"}
    classes={{ paper: classes.paper }}
  >
    <DialogTitle id="no-rep-code-modal-title" disableTypography>
      <SectionHeader text={"Notice"} />
    </DialogTitle>
    <DialogContent className={classes.dialogContent}>
      <Typography variant={"subtitle1"}>
        Your CRD Reference is not Verified. In order to effectively open
        accounts for your clients please fill out and verify your CRD Reference.
      </Typography>
      <TextField
        required
        type={"number"}
        inputProps={{ "aria-label": "Advisor CRD Reference" }}
        onChange={(e) => setCRD(e.target.value)}
        value={crd}
      />
      {
        message && message.error && <ErrorMessage>{message.error}</ErrorMessage>
      }
    </DialogContent>
    <DialogActions>
      <Button
        variant="contained"
        color="primary"
        onClick={() => dispatch(userAction.saveUserProfile({ advisorCrdRef: crd }))}
        disabled={crd === ''}
      >
        Verify
      </Button>
    </DialogActions>
  </Dialog>;
};

export default withStyles(styles)(VerifyCRD);



// WEBPACK FOOTER //
// ./src/containers/Notifications/VerifyCRD/index.jsx